import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@material-ui/core';

const ProtectedRoute = ({ component: Component, adminOnly = false, ...rest }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        style={{ backgroundColor: '#f5f5f5' }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated()) {
          return <Redirect to="/login" />;
        }

        if (adminOnly && !isAdmin()) {
          return <Redirect to="/" />;
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
